<template>
  <v-container class="pa-0">
    <EditContactInfo
      v-if="showEditContactInfo"
      :email="email"
      :phone="phoneNumber"
      :address1="address"
      :address2="address2"
      :city="city"
      :state="state"
      :zip="zip"
      :is-canada="!!currentPolicy.isCanadaPolicy"
      :editing-category="editingCategory"
      @closeeditcontact="closeEditContact()"
    />
    <v-card flat rounded="0">
      <v-card-title>
        <h1 role="heading" aria-level="2" class="text-h2">
          {{ $t('L_policy_policy_owner') }}
        </h1>
      </v-card-title>
      <v-divider />
      <!-- TODO verify if needed -->
      <!-- <div
        v-slot="header"
        ref="contact"
        tabindex="0"
        role="button"
        @click="panelOpen = !panelOpen"
        id="policy_view_contact_details_container"
        @click.stop="togglePanel(contactDetailsPanel)"
      >
        <div id="policy_view_contact_details">
          {{ $t('L_policy_view_contact_details') }}
        </div>
      </div> -->
      <v-card-text class="grey-lighten-5 pt-4" :class="$vuetify.display.xs ? '' : 'py-4'">
        <v-row v-if="allowEdit && !(editContactInfo || editing)" class="pb-4" justify="center">
          <!-- ! Name -->
          <v-col cols="12" sm="12" md="4" class="py-4 px-4" justify="left">
            <v-row>
              <v-col cols="12" class="pb-0">
                <h3 class="text-h3 font-weight-bold">{{ $t('L_Name') }}</h3>
              </v-col>
              <v-col cols="12" class="pb-3">
                <span class="text-body-1">{{ policyOwner?.name }}</span>
              </v-col>
              <v-col cols="12">
                <p class="text-body-1">
                  {{ $t('L_for_information_on_changing_the_policy_owner_name')
                  }}<span>
                    <a @click="clickHerePolicyOwner" class="blueLinkPointer">
                      {{ $t('L_click_here') }}
                    </a></span
                  >
                </p>
              </v-col>
            </v-row>
          </v-col>
          <!-- ! Contact Info -->
          <v-col cols="12" sm="12" md="8" class="py-4 px-4">
            <v-row justify-left>
              <v-col cols="12" class="font-weight-bold pb-2">
                <h3 class="text-h3 font-weight-bold">{{ $t('L_contact_info') }}</h3>
              </v-col>
              <v-col cols="1" sm="1" class="pb-3" :class="$vuetify.display.xs ? 'pl-0 pr-0' : ''">
                <span class="inlineText">
                  <v-icon color="#333333" :icon="mdiEmail" />
                </span>
              </v-col>
              <v-col cols="7" sm="9" class="pb-3">
                <span class="text-body-1 inlineText pl-0 wordBreakAll" v-if="email !== ''">{{
                  email
                }}</span>
                <span class="text-body-1 inlineText pl-0 wordBreakAll" v-if="email === ''">{{
                  $t('L_information_not_on_file')
                }}</span>
              </v-col>
              <v-col cols="4" sm="2" class="pb-3 pr-0">
                <a
                  v-if="allowEdit && !isPending && !(editContactInfo || editing)"
                  @click="
                    editingCategory = 'email';
                    showEditContactInfo = true;
                  "
                >
                  <span class="blueLinkPointer" v-if="email !== ''">{{ $t('L_edit') }}</span>
                  <span class="blueLinkPointer" v-if="email === ''">{{ $t('L_add') }}</span>
                </a>
              </v-col>
              <v-col cols="1" sm="1" class="pb-3" :class="$vuetify.display.xs ? 'pl-0 pr-0' : ''">
                <span class="inlineText">
                  <v-icon color="#333333" :icon="mdiPhone" />
                </span>
              </v-col>
              <v-col cols="7" sm="9" class="font-size--16 pb-3 pr-0">
                <span class="text-body-1 inlineText pl-0" v-if="phoneNumber !== ''">{{
                  phoneFormat(phoneNumber)
                }}</span>
                <span class="text-body-1 inlineText pl-0" v-if="phoneNumber === ''">{{
                  $t('L_information_not_on_file')
                }}</span>
              </v-col>
              <v-col cols="4" sm="2" class="pb-3 pr-0">
                <a
                  v-if="allowEdit && !isPending && !(editContactInfo || editing)"
                  @click="
                    editingCategory = 'phone';
                    showEditContactInfo = true;
                  "
                >
                  <span class="blueLinkPointer" v-if="phoneNumber !== ''">{{ $t('L_edit') }}</span>
                  <span class="blueLinkPointer" v-if="phoneNumber === ''">{{ $t('L_add') }}</span>
                </a>
              </v-col>
              <v-col cols="1" sm="1" class="pb-3" :class="$vuetify.display.xs ? 'pl-0 pr-0' : ''">
                <span class="inlineText">
                  <v-icon color="#333333" :icon="mdiHome" />
                </span>
              </v-col>
              <v-col cols="7" sm="9" class="pb-3">
                <span class="text-body-1 inlineText pl-0" v-if="address !== ''"
                  >{{ address }},</span
                >
                <div class="text-body-1 pl_address_line_two pl-0" v-if="address2">
                  {{ address2 }},
                </div>
                <div class="text-body-1 pl_address_line_two pl-0">
                  {{ city }}, {{ state }} {{ zip }}
                </div>
                <div class="text-body-1 inlineText pl-0" v-if="address === ''">
                  {{ $t('L_information_not_on_file') }}
                </div>
              </v-col>
              <v-col cols="4" sm="2" class="pb-3 pr-0">
                <a
                  v-if="allowEdit && !isPending && !(editContactInfo || editing)"
                  @click="
                    editingCategory = 'address';
                    showEditContactInfo = true;
                  "
                >
                  <span class="blueLinkPointer" v-if="address !== ''">{{ $t('L_edit') }}</span>
                  <span class="blueLinkPointer" v-if="address === ''">{{ $t('L_add') }}</span>
                </a>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script lang="ts">
// import { required, maxLength } from '@vuelidate/validators';
import { openInNewWindow } from '@/mixins/openNewWindow';
// import bff from '@/shared/api/bff';
import EditContactInfo from './PolicyOwnerEditContactInfo.vue';
import { defineComponent, type ComponentOptions } from 'vue';
import { usePolicyStore } from '@/modules/policy/store/policy.store';
import { useGlobalStore } from '@/stores/global/global.store';
import { mapActions, mapState, mapStores } from 'pinia';
import { useCustomerStore } from '@/stores/customer/customer.store';
import { useVuelidate } from '@vuelidate/core';
import { mdiEmail, mdiPhone, mdiHome } from '@mdi/js';
import { UILocale } from '@/shared';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';

const componentOptions: ComponentOptions = {
  name: 'PolicyOwner',
  setup() {
    const vuelidate = useVuelidate();
    return { vuelidate };
  },
  components: {
    EditContactInfo,
  },
  props: {
    allowEdit: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data: () => ({
    editing: false,
    phoneNumber: '',
    email: '',
    address: '',
    address2: '',
    city: '',
    state: '',
    zip: '',
    panelOpen: false,
    showEditContactInfo: false,
    editingCategory: '',
    mdiEmail,
    mdiPhone,
    mdiHome,
  }),
  computed: {
    ...mapStores(usePolicyStore, useGlobalStore),
    ...mapState(useGlobalStore, {
      locale: 'getLocale',
    }),
    ...mapState(useCustomerStore, ['customerProfile']),
    ...mapState(usePolicyStore, {
      isPending: 'isPending',
      addressVerification: 'addressVerification',
      addressUpdateSuccess: 'addressUpdateSuccess',
      policyOwner: 'policyOwner',
      currentPolicy: 'currentPolicy',
      contactDetailsPanel: 'contactDetailsPanel',
      editContactInfo: 'editContactInfo',
      selectedPolicyIndex: 'selectedPolicyIndex',
    }),
    canEdit() {
      return (this.editContactInfo || this.editing) && this.allowEdit;
    },
    emailToSend() {
      return this.email.length > 0 ? this.email : ' ';
    },
    getSelectedPolicyIndex() {
      return this.selectedPolicyIndex;
    },
    getEmail() {
      return (
        this.currentPolicy?.data?.clientEmailaddress ||
        this.policyOwner?.email ||
        this.customerProfile.email
      );
    },
    getPhoneNumber() {
      return (
        this.currentPolicy?.data?.phoneNumber ||
        this.policyOwner?.address.phone ||
        this.customerProfile.mobilePhone
      );
    },
    getAddress() {
      return (
        this.currentPolicy?.data?.ownerAddress.address1 || this.policyOwner?.address.address1 || ''
      );
    },
    getAddress2() {
      return (
        this.currentPolicy?.data?.ownerAddress.address2 || this.policyOwner?.address.address2 || ''
      );
    },
    getCity() {
      return this.currentPolicy?.data?.ownerAddress.city || this.policyOwner?.address.city || '';
    },
    getState() {
      return this.currentPolicy?.data?.ownerAddress.state || this.policyOwner?.address.state || '';
    },
    getZip() {
      return this.currentPolicy?.data?.ownerAddress.zip || this.policyOwner?.address.zip || '';
    },
  },
  mixins: [openInNewWindow],
  methods: {
    ...mapActions(usePolicyStore, {
      setContactInfoEdit: 'setContactInfoEdit',
    }),
    phoneFormat(value: string) {
      if (value.length === 10) {
        return `(${value.substr(0, 3)}) ${value.substr(3, 3)}- ${value.substr(6, 4)}`;
      }
      return '';
    },
    async clickHerePolicyOwner() {
      let embedUrl;
      const isWeb = CapacitorFacade.isWeb();
      if (this.$i18n.locale === UILocale.FR_CA.toString()) {
        // https://primerica-auth2-stg.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=221109104826097&page=1&position=0&q=Changer%20le%20nom%20de%20la%20personne%20assur%C3%A9e%20ou%20du%20titulaire%20de%20la%20police&sl=true%22
        embedUrl = window.appConfig.life.Policy_Owner_Name_Change_fr;
      } else {
        // https://primerica-auth2-stg.rightanswers.com/portal/app/portlets/results/viewsolution.jsp?solutionid=210414161158720&page=1&position=0&q=owner%20name&sl=true%22
        embedUrl = window.appConfig.life.Policy_Owner_Name_Change_en;
      }
      await this.openInNewWindow({
        url: embedUrl,
        inappbrowser: !isWeb,
        target: 'RADashboardWinName',
      });
    },

    togglePanel(currentPanelValue: number) {
      if (currentPanelValue === 0) {
        this.policyStore.setContactDetailsPanel(-1);
      } else {
        this.policyStore.setContactDetailsPanel(0);
      }
    },
    // TODO: Review & update if necessary after policy-ds is converted to mule service

    reset() {
      this.email = this.policyOwner?.email || '';
      this.phoneNumber = this.policyOwner?.address.phone || '';
      this.address = this.policyOwner?.address.address1 || '';
      this.address2 = this.policyOwner?.address.address2 || '';
      this.city = this.policyOwner?.address.city || '';
      this.state = this.policyOwner?.address.state || '';
      this.zip = this.policyOwner?.address.zip || '';
      this.editing = false;
      this.setContactInfoEdit(false);
      try {
        return this.vuelidate?.$reset();
      } catch (_error) {
        /* empty */
      }
    },
    closeEditContact() {
      this.showEditContactInfo = false;
      this.reset();
    },
  },
  mounted() {
    this.reset();
  },
  watch: {
    addressUpdateSuccess(newData, oldData) {
      /*
       * Emit a custom action when a user successfully submits an update mobile number request
       * https://www7.v1host.com/Primerica/attachment.img/284635/Analytics%20User%20Stories%20DT_3.30.21.docx
       */
      const i = this.$dynatrace.enterAction('policy_contact_details_changes_saved');
      this.$dynatrace.leaveAction(i);
      if (!oldData && newData) {
        this.editing = false;
      }
    },
    getSelectedPolicyIndex(newIndex, oldIndex) {
      if (newIndex !== oldIndex) {
        this.reset();
      }
    },
  },
};

export default defineComponent(componentOptions);
</script>

<style lang="scss" scoped>
.blue-border {
  border: solid 2px #2196f3;
}
.select-address {
  color: #2196f3 !important;
}
.blueLinkPointer {
  text-decoration: none;
  color: rgb(12, 109, 202);
  font-weight: 600;
  cursor: pointer;
}
.wordBreakAll {
  word-break: break-all;
}
</style>
